





















import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import { Prop } from 'vue-property-decorator'

@Component
export default class StepBar extends Vue {
  @Prop({ default: '2' }) readonly stepNow!: string
  @Prop({
    default: () => ['انتخاب رسانه', 'بازبینی سفارش', 'پرداخت', 'پایان ثبت سفارش']
  }) readonly steps!: string[]

}
